// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Filter40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Filter40: FC<Filter40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M21.667 15.278V12.5h5.278V5h2.777v7.5H35v2.778H21.667ZM26.945 35V18.055h2.777V35h-2.777Zm-16.667 0v-7.222H5V25h13.333v2.778h-5.278V35h-2.777Zm0-12.778V5h2.777v17.222h-2.777Z" />
        </svg>
    );
};

export default Filter40;
